import {Select} from "antd";
import {useAppContext} from "../../../Context/ProjectContextV2";

export default function LayerSearch({onChange, type}) {
    const {mapContext, getSelectedHistory, getCSList, getMapData} = useAppContext()

    const getData = () => {
        const data = getMapData(type || 'base')
        const list = []

        for (const item of (data?.cross_sections || [])) {
            list.push({
                _text: item.cross_section,
                xy: item.xy,
                type: 'cross_section'
            })
        }

        for (const item of (data?.structures || [])) {
            let type = 'Culv'
            if(item.typeName === 'Bridge')
                type = 'BR'
            else if(item.typeName === 'MultipleOpening')
                type = 'MO'
            else if(item.typeName === 'InlineStructure')
                type = 'IS'
            else if(item.typeName === 'LateralStructure')
                type = 'LS'

            list.push({
                _text: `${item.cross_section} ${type}`,
                xy: item.xy,
                type: 'cross_section'
            })
        }
        list.sort(function(a, b) {
            return parseFloat(a._text) - parseFloat(b._text);
        });
        list.reverse()

        return list
    }

    return (
        <Select
            suffixIcon={(<div style={{marginRight: 16}}>All River Stations</div>)}
            size={'small'}
            style={{width: 200}}
            allowClear={true}
            onChange={(e) => {
                const item = getData()?.find(x => x._text === e)
                if(item)
                    onChange && onChange(item)
            }}
            showSearch={true}
            filterOption={(input, option) => {
                let find = false
                for (const key of Object.keys(option)) {
                    if(option[key]?.toString()?.toLowerCase()?.includes(input?.toString()?.toLowerCase()))
                    {
                        find = true
                        break
                    }
                }
                return find
            }}
        >
            {
                getData()?.map(x => (
                    <Select.Option value={x._text}>
                        {x._text}
                    </Select.Option>
                ))
            }
        </Select>
    )
}